import Form, { AIEngineFormMode } from "./Form";
import React, { useContext, useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { HomeAppContext } from "../Home";
import api from "../../Services/api";
import { errorManagement } from "../../Services/errorManagement";
import GenericDialog from "../GenericDialog";

export default function Edit({ open, setOpen, entry, onEdit }) {
  const { homeDispatch } = useContext(HomeAppContext);
  const [internalEntry, setInternalEntry] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState([]);
  const [initialApiUrl, setInitialApiUrl] = useState("");
  const [initialApiToken, setInitialApiToken] = useState("");
  const [connectionNeedsTested, setConnectionNeedsTested] = useState(true);
  const [familiesFromApi, setFamiliesFromApi] = useState([]);
  const [groupsFromApi, setGroupsFromApi] = useState([]);

  React.useEffect(() => {
    if (entry !== null && open) {
      setInternalEntry(entry);
      setErrors([]);
      setLoading(false);
      setSubmitted(false);
      setInitialApiUrl(entry.apiUrl);
      setInitialApiToken(entry.apiToken);
      setConnectionNeedsTested(true);
      getEngineFamilies();
      getEngineGroups();
    } else {
      setInternalEntry(null);
    }
  }, [entry, open]);

  const handleClose = () => {
    setOpen(false);
    setLoading(true);
  };

  const handleTestConnection = () => {
    const testDto = {
      engineName: internalEntry.engineName,
      apiUrl: internalEntry.apiUrl,
      apiToken: internalEntry.apiToken,
      engineFamily: internalEntry.engineFamily
    };
    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Testing AI Engine connection", loading: true }
    });
    api
      .post("/api/ai-engines/test-connection", testDto)
      .then((r) => {
        if (r.data) {
          homeDispatch({
            type: "NOTIFICATION",
            data: {
              message: "Testing AI Engine connection success",
              type: "success"
            }
          });
          setConnectionNeedsTested(false);
        }
      })
      .catch((error) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message:
              "Testing AI Engine connection failed: " + error.response.data,
            type: "error"
          }
        });
      });
  };

  const handleCloseSave = () => {
    const updateEngine = {
      id: internalEntry.id,
      engineName: internalEntry.engineName,
      apiUrl: internalEntry.apiUrl,
      apiToken: internalEntry.apiToken,
      description: internalEntry.description,
      isAvailableToTeam: internalEntry.isAvailableToTeam,
      isAssistant: internalEntry.isAssistant,
      isActive: internalEntry.isActive,
      isDefault: internalEntry.isDefault,
      apiCost: internalEntry.apiCost,
      engineFamily: internalEntry.engineFamily,
      temperature: internalEntry.temperature,
      engineGroup: internalEntry.engineGroup,
      maxTokens: internalEntry.maxTokens,
      maxCalls: internalEntry.maxCalls
    };

    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Updating " + internalEntry.engineName, loading: true }
    });
    setSubmitted(true);
    setLoading(true);
    api
      .put(`/api/ai-engines/${updateEngine.id}`, updateEngine)
      .then((response) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message: internalEntry.engineName + " updated",
            type: "success"
          }
        });
        setOpen(false);
        setLoading(false);
        onEdit();
      })
      .catch((error) => {
        setLoading(false);
        errorManagement.formErrors(error, homeDispatch, setErrors);
      });
  };

  const getEngineFamilies = () => {
    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Fetching engine families", loading: true }
    });
    api
      .get("/api/ai-engines/family/dropdown")
      .then((r) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message: "Engine families fetched successfuly",
            type: "success"
          }
        });
        setFamiliesFromApi(r.data);
      })
      .catch((error) => errorManagement.formErrors(error, homeDispatch));
  };

  const getEngineGroups = () => {
    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Fetching engine groups", loading: true }
    });
    api
      .get("/api/ai-prompts/group/dropdown")
      .then((r) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: {
            message: "Engine groups fetched successfuly",
            type: "success"
          }
        });
        setGroupsFromApi(r.data);
      })
      .catch((error) => errorManagement.formErrors(error, homeDispatch));
  };

  useEffect(() => {
    if (
      internalEntry &&
      (internalEntry.apiUrl !== initialApiUrl || internalEntry.apiToken !== initialApiToken)
    ) {
      setConnectionNeedsTested(true);
    } else {
      setConnectionNeedsTested(false);
    }
  }, [internalEntry, initialApiUrl, initialApiToken]);
  const actions = (
    <>
      <Button onClick={handleClose} disabled={loading}>
        Cancel
      </Button>
      {connectionNeedsTested === true ? (
        <Button
          onClick={handleTestConnection}
          variant="outlined"
          color="primary"
        >
          Test Connection
        </Button>
      ) : (
        <Button
          onClick={handleCloseSave}
          color="primary"
          variant="outlined"
          autoFocus
          disabled={loading || saveDisabled}
        >
          Save Engine
        </Button>
      )}
    </>
  )
  return internalEntry === null ? null : (
    <GenericDialog
      maxWidth={"md"}
      open={open}
      onClose={handleClose}
      title={"Edit AI Engine"}
      actions={actions}
    >
        <Form
          mode={AIEngineFormMode.EDIT}
          entity={internalEntry}
          errors={errors}
          setEntity={setInternalEntry}
          loading={loading}
          submitted={submitted}
          setSaveDisabled={setSaveDisabled}
          engineFamilies={familiesFromApi}
          engineGroups={groupsFromApi}
        />
    </GenericDialog>
  );
}
